import { formatInterest } from "utilities/currencyHelper";
import { SAVING_ACCOUNTS_FLOWS } from "../../../constants/eAccountLoan";
import { getIsFullProfitability } from "../../../utilities/depositHelper";
import { i18n } from "core/i18n";
const { formatText, FormattedText, FormattedTextWithNamedVariables, getNamedVariables } = i18n;
import depositIcon from 'assets/icons/deposittransfer.png';
import savingsAccountIcon from 'assets/icons/savings-account-openbank.svg';
import {
    SAVINGS_WITHOUT_CONDITION_WITHOUT_TERM,
    SAVINGS_WITHOUT_CONDITION_WITH_TERM,
    SAVINGS_WITH_CONDITION_WITH_TERM,
    SAVINGS_WITH_CONDITION_WITHOUT_TERM
} from 'constants/eAccountLoan'
import { ACCOUNT_RETENTION_EXCLUSIVE_OFFER, DEPOSIT_RETENTION_EXCLUSIVE_OFFER } from "../../../constants/flagBasedFeatures";

const PRODUCT_TYPE_FLAGS = {
    SAVINGS_ACCOUNT: ACCOUNT_RETENTION_EXCLUSIVE_OFFER,
    TRANSFER_DEPOSIT: DEPOSIT_RETENTION_EXCLUSIVE_OFFER,
    TRANSFER_ACCOUNT: ACCOUNT_RETENTION_EXCLUSIVE_OFFER,
    SAVINGS_ACCOUNT_LIMIT: ACCOUNT_RETENTION_EXCLUSIVE_OFFER
}

const TAGGING = {
    SAVINGS_ACCOUNT: {
        etiquetaEvento: "consigue tu cuenta",
        element: "hireAccount",
    },
    TRANSFER_DEPOSIT: {
        etiquetaEvento: "consigue tu deposito",
        element: "hireDeposit",
    },
    TRANSFER_ACCOUNT: {
        etiquetaEvento: "traspasa a tu cuenta",
        element: "transferToYourAccount",
    },
    SAVINGS_ACCOUNT_LIMIT: {
        etiquetaEvento: "consigue tu cuenta",
        element: "hireAccount",
    }
}

const CONTEXT = 'contractsView';
const EXAMPLE_TEXTS = {
    [SAVINGS_WITHOUT_CONDITION_WITHOUT_TERM]: `${CONTEXT}-savingsRepresentativeExample_SBSP`,
    [SAVINGS_WITHOUT_CONDITION_WITH_TERM]: `${CONTEXT}-savingsRepresentativeExample_SBCP`,
    [SAVINGS_WITH_CONDITION_WITHOUT_TERM]: `${CONTEXT}-savingsRepresentativeExample_CBSP`,
    [SAVINGS_WITH_CONDITION_WITH_TERM]: `${CONTEXT}-savingsRepresentativeExample_CBCP`,
}

const ICONS = {
    SAVINGS_ACCOUNT: savingsAccountIcon,
    TRANSFER_DEPOSIT: depositIcon,
    TRANSFER_ACCOUNT: savingsAccountIcon,
    SAVINGS_ACCOUNT_LIMIT: savingsAccountIcon
};

const FLOW_MAP = {
    DEPOSIT_HIRING_FLOW: "TRANSFER_DEPOSIT",
    ACCOUNT_TRANSFER_FLOW: "TRANSFER_ACCOUNT",
    ACCOUNT_LIMIT_FLOW: "SAVINGS_ACCOUNT_LIMIT"
};

const URLS = {
    SAVINGS_ACCOUNT: "/myprofile/purchase/e-account-loan",
    TRANSFER_DEPOSIT: "/myprofile/purchase/deposittransfer",
    TRANSFER_ACCOUNT: "/myprofile/transfers/pass",
    SAVINGS_ACCOUNT_LIMIT: "",
};

const TEXTS = {
    SAVINGS_ACCOUNT: {
        title: "offers-transfers_offerTitle",
        subtitle: "offers-transfers_savingsAccountSubTitle",
        months: 'offers-atMonthsLabel',
        headline: "offers-transfers_savingsAccountHeadline",
        taeText: "offers-transfers_offerTAE",
        tinSameAsTaeText: "offers-transfers_offerTINsameAsTAE",
        tinText: "offers-transfers_offerTIN",
        buttonText: "offers-transfers_savingsOfferLink",
    },
    TRANSFER_DEPOSIT: {
        subheading: "offers-transfers_offerDepositHeading",
        title: "offers-transfers_offerTitle",
        subtitle: "offers-transfers_offerSubTitle",
        headline: "offers-transfers_offerHeadline",
        taeText: "offers-transfers_offerTAE",
        tinSameAsTaeText: "offers-transfers_offerTINsameAsTAE",
        tinText: "offers-transfers_offerTIN",
        buttonText: "offers-transfers_offerLink"
    },
    TRANSFER_ACCOUNT: {
        title: "offers-transfers_offerTitle",
        subtitle: "offers-transfers_savingsAccountSubTitle",
        months: 'offers-atMonthsLabel',
        headline: "offers-transfers_accountTransferHeadline",
        taeText: "offers-transfers_offerTAE",
        tinSameAsTaeText: "offers-transfers_offerTINsameAsTAE",
        tinText: "offers-transfers_offerTIN",
        buttonText: "offers-transfers_accountTransferLink"
    },
    SAVINGS_ACCOUNT_LIMIT: {
        title: "offers-transfers_offerTitle",
        subtitle: "offers-transfers_savingsAccountSubTitle",
        months: 'offers-atMonthsLabel',
        headline: "offers-transfers_savingsAccountHeadline",
        taeText: "offers-transfers_offerTAE",
        tinSameAsTaeText: "offers-transfers_offerTINsameAsTAE",
        tinText: "offers-transfers_offerTIN",
        buttonText: "offers-transfers_savingsOfferLink"
    }
};

const getCommonTagging = (type, subtype) => ({
    categoriaEvento: "modal transferencia de deposito",
    accionEvento: "clickLink",
    action: "click",
    format: "link",
    component: "modal/transferDeposit",
    productName: `${type}.${subtype}`,
});

const getTypeOfProduct = (flowId) => {
    if (SAVING_ACCOUNTS_FLOWS.includes(flowId)) {
        return "SAVINGS_ACCOUNT";
    };

    return FLOW_MAP[flowId];
};

const getUrl = (item) => {
    const { flowId, productId } = item;
    const productType = getTypeOfProduct(flowId);
    if (productType === "SAVINGS_ACCOUNT") {
        return `${URLS[productType]}/${productId}`;
    };
    return URLS[productType];
};

const getRedirectionObject = (item) => {
    const { flowId, standard, type, subtype } = item;
    const productType = getTypeOfProduct(flowId);
    switch (productType) {
        case "SAVINGS_ACCOUNT":
            return {
                url: getUrl(item),
            };
        case "TRANSFER_DEPOSIT":
            return {
                url: getUrl(item),
            };
        case "TRANSFER_ACCOUNT":
            return {
                url: getUrl(item),
                redirectionState: {
                    standard,
                    type,
                    subtype,
                }
            };
        case "SAVINGS_ACCOUNT_LIMIT":
            return {
                url: getUrl(item),
            };
    };
};

const getAPIText = (item, text) => {
    const { metadata } = item;
    const { context, accountConfig } = metadata;
    return `${context}-${accountConfig[text]}`;
}

const getTexts = (item, amount, originCountry) => {
    const { offersValues, tae, tin, flowId } = item;
    const productType = getTypeOfProduct(flowId);
    const textsNames = TEXTS[productType];
    const isFullRates = getIsFullProfitability(originCountry);

    const textsObject = {
        subheading: {
            text: textsNames.subheading ? textsNames.subheading : getAPIText(item, 'name'),
            ...(productType === "TRANSFER_DEPOSIT" && { injectedStrings: [offersValues.months] }),
        },
        ...((textsNames.months && offersValues.months) && {
            months: {
                text: textsNames.months,
                injectedStrings: [offersValues.months],
            },
        }),
        title: {
            text: textsNames.title,
            injectedStrings: [formatInterest(offersValues.grossInterest, false)]
        },
        subtitle: {
            text: textsNames.subtitle,
            ...(productType !== "TRANSFER_DEPOSIT" && { injectedStrings: [formatInterest(amount, false)] })
        },
        headline: {
            text: textsNames.headline
        },
        firstRateText: {
            text: textsNames.taeText,
            injectedStrings: isFullRates ? [formatInterest(tae, false)] : [formatInterest(tin, false)]
        },
        secondRateText: {
            text: tae === tin ? textsNames.tinSameAsTaeText : textsNames.tinText,
            injectedStrings: tae === tin ? [] : [formatInterest(tin, false)]
        },
        buttonText: {
            text: textsNames.buttonText
        }
    };

    const formattedTexts = {};

    Object.entries(textsObject).forEach(([key, { text, injectedStrings }]) => {
        formattedTexts[key] = (
            <FormattedText
                value={text}
                {...(injectedStrings && { injectedStrings })}
            />
        );
    });

    return formattedTexts;

};

const getTagging = (item, productType) => {
    const { type, subtype } = item;
    return {
        ...getCommonTagging(type, subtype),
        ...TAGGING[productType]
    };
};

const getBackgroundColor = (productType) => {
    switch (productType) {
        case "SAVINGS_ACCOUNT":
            return "#e1e1f3";
        case "TRANSFER_DEPOSIT":
            return "#cce8f0";
        case "TRANSFER_ACCOUNT":
            return "#e1e1f3";
        case "SAVINGS_ACCOUNT_LIMIT":
            return "#e1e1f3";
    };
}

const getItem = (item, amount, originCountry) => {
    const { flowId, productId } = item;
    const texts = getTexts(item, amount, originCountry);
    const productType = getTypeOfProduct(flowId);

    return {
        ...texts,
        redirection: getRedirectionObject(item),
        icon: ICONS[productType],
        tagging: getTagging(item, productType),
        productId,
        flowId,
        backColor: getBackgroundColor(productType)
    };
};

const getExample = (item, index) => {
    const { offersValues, tae, tin, flowId, metadata } = item;
    const { accountType, accountConfig } = metadata;
    const productType = getTypeOfProduct(flowId);
    let exampleObject = {};
    if (productType === "TRANSFER_DEPOSIT") {
        exampleObject = {
            values: [
                index + 1,
                formatInterest(offersValues.exampleAmount, false),
                formatInterest(tae, false),
                ...(tae === tin ? [] : [formatInterest(tin, false)]),
                offersValues.months,
                offersValues.months,
                formatInterest(offersValues.exampleInterestAmount, false),
                offersValues.months,
                offersValues.cancelMonths,
                formatInterest(offersValues.cancelCost, false),
                formatInterest(offersValues.exampleInterestAmountCancelled, false),
            ],
            text: tae === tin ? "offers-transfers_offersExample" : "offers-transfers_offersExampleTINandTAE",
        };

        return <FormattedText
            value={exampleObject.text}
            injectedStrings={exampleObject.values}
        />

    } else {
        const config = { ...offersValues, ...accountConfig}
        exampleObject = {
            values: {
                ...config,
                exampleAmount: formatInterest(offersValues.exampleAmount, false),
                tae: formatInterest(tae, false),
                tin: formatInterest(tin, false),
                superIndex: index + 1,
            },
            text: EXAMPLE_TEXTS[accountType]
        };
        return <FormattedTextWithNamedVariables
            value={exampleObject.text}
            namedVariables={getNamedVariables(exampleObject.text, { ...exampleObject.values })}
        />
    };
};

const getMonthsForBetterOffer = (betterDealOffer) => {
    const productType = getTypeOfProduct(betterDealOffer.flowId);
    if (productType === "SAVINGS_ACCOUNT") {
        return betterDealOffer.offersValues.months || betterDealOffer.metadata.accountConfig.exampleMonths
    }
    return betterDealOffer.offersValues.months
}


export const offersTransfersAdapter = (offers = {}, contextData) => {
    const {
        immProfile,
        immFirstStep,
        immFlagBasedFeatures
    } = contextData;
    let filteredOffers = offers.offers.filter(item => {
        const productType = getTypeOfProduct(item.flowId);
        return immFlagBasedFeatures.get(PRODUCT_TYPE_FLAGS[productType]);
    });

    if (!filteredOffers.length || !offers.isClientAcceptingOffers) {
        return {
            offers: [],
        };
    }

    let examples = [];
    let offerItems = [];
    let betterDealOffer = filteredOffers[0];
    
    filteredOffers.forEach((item, index) => {
        offerItems.push(getItem(item, immFirstStep.getIn(["amount"]), immProfile.get("originCountry")));
        examples.push(getExample(item, index));
        if (Number(item.offersValues.grossInterest) > Number(betterDealOffer.offersValues.grossInterest)) {
            betterDealOffer = item;
        }
    });
    const betterDealOfferMonths = getMonthsForBetterOffer(betterDealOffer)

    return {
        title: [immProfile.get('nombreCliente'),
        formatInterest(immFirstStep.getIn(["amount"]), false)
        ],
        subtitleWithBetterDeal: [
            formatInterest(betterDealOffer.offersValues.grossInterest, false),
            betterDealOfferMonths,
        ],
        offers: offerItems,
        examples
    };
};
